<template>
  <div id="history" class="px-6 py-10 lg:max-w-4xl lg:mx-auto relative">
    <div class="flex justify-start">
      <img
        class="w-full md:w-2/3 object-contain md:pr-6"
        src="../assets/images/history/history-1.jpg"
        alt
      />
      <img
        class="w-1/3 mt-64 object-contain hidden md:block"
        src="../assets/images/history/history-2.jpg"
        alt
      />
    </div>

    <p class="ts pt-6 font-bold texto-roboto text-primary line120">History</p>
    <span class="flex w-16 h-1.5 mt-4 mb-6 md:mb-8 bg-accent"></span>
    <div
      class="highlighted text-primary text-xl md:text-2xl mb-6 md:mb-8 md:w-5/6"
    >
      <p>
        GoldenRace's founders spent many years wondering what they could do to
        give back to the community in the most impactful way.
      </p>
    </div>

    <div class="more text-gray-700 md:w-5/6 lg:ml-auto">
      <p>
        During their business trips around the world, they discovered incredible
        places where there were children with necessities, and they instantly
        felt there was an opportunity for doing something.
      </p>
      <p>
        This is why they decided to create the GoldenRace Foundation in 2015 in
        the form of a Corporate Direct Giving Programme.
      </p>
      <p>A passionate project to change children’s future.</p>
      <p>
        The first collaboration was with Child Africa, in Uganda, and then we
        added Kibera Celtic Foundation in Kenya, where sports play a key
        role together with formal education. More recently we started working
        with a school in Nepal.
      </p>
      <p>And we hope to keep on growing and helping in different locations.</p>
    </div>

    <div class="images-history flex flex-row mt-16">
      <img
        class="w-1/2 pr-2 md:px-3 object-contain mb-32"
        src="../assets/images/history/history-3.jpg"
        alt=""
      />
      <img
        class="w-1/2 pl-2 md:px-3 mt-32"
        src="../assets/images/history/history-4.jpg"
        alt=""
      />
    </div>

    <Quote
      class="pt-24"
      text='"Children are like wet cement. Whatever falls on them makes an impression"'
      author="HAIM GINOTT"
    />
  </div>
</template>

<script>
import Quote from "@/components/parts/Quote";

export default {
  name: "History",
  components: {
    Quote,
  },
};
</script>

<style scoped>
.more p {
  padding-bottom: 1rem;
}

.more {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 170%;
  letter-spacing: 0.4px;
}

@media screen and (min-width: 767px) {
  .more {
    font-size: 18px;
  }
}

.highlighted {
  font-weight: 500;
}

.max-w-194 {
  max-width: 19.4rem;
}

@media screen and (max-width: 766px) {
  .container {
    max-width: 100%;
  }
}
</style>
